<template>
    <div>
        <el-dialog title="推荐" :visible.sync="dialogVisble" width="70%" :before-close="hideDialogRecommend" :close-on-click-modal="false">
            <!--查询条件start --111s-->
            <el-form :inline="true" :model="querys" class="query-form" size="small">
                <el-form-item class="query-form-item">
                    <el-select v-model="querys.classifyid" placeholder="请选择分类" clearable @change="onSubmits">
                        <el-option v-for="(item, index) in comClassifys" :key="index" :label="item.classifytitle" :value="item.classifyid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="query-form-item">
                    <el-select v-model="querys.brandid" placeholder="请选择场景" clearable @change="onSubmits">
                        <el-option v-for="(item, index) in comSence" :key="index" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="query-form-item">
                    <el-input v-model="querys.commodityname" placeholder="请输入商品名称" prefix-icon="el-icon-search" @keyup.enter.native="onSubmits" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-refresh" @click="onRests"></el-button>
                    <el-button type="primary" icon="el-icon-search" @click="onSubmits">查询</el-button>
                    <el-button type="primary" @click="showDialogAlreadRecommend">查看已添加列表（{{ count }}）</el-button>
                </el-form-item>
            </el-form>
            <!--查询条件end --111e-->
            <el-table ref="multipleTable" v-loading="loadings" :data="lists" :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" border>
                <el-table-column label="缩略图" prop="commodityurl" width="80" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.commodityurl" style="width: 50px;height: 50px;" />
                    </template>
                </el-table-column>
                <el-table-column label="产品编码" prop="commoditynum" align="center" />
                <el-table-column label="商品名称" prop="commodityname" :show-overflow-tooltip="true" align="center" />
                <el-table-column label="分类" prop="classifytitle" align="center" />
                <!-- <el-table-column label="品牌" prop="brandtitle" align="center" /> -->
                <el-table-column label="价格" align="center" prop="specprice">
                    <template slot-scope="scope">
                        <span v-if="scope.row.specprice">{{scope.row.specprice | price(scope.row.specprice)}}</span>
                        <span v-else>0</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号" prop="commoditysort" align="center" />
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click.native="addRecomCommodity(scope.row.commodityid)">
                            添加
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-pagination class="pagination-container" background :page-size="querys.pageSize" @size-change="handleSizeChanges" @current-change="handleCurrentChanges" layout="total,sizes,prev, pager, next, jumper" :current-page="querys.currentPage" :page-sizes="[6, 12, 36, 80]" :total="totalNumbers"></el-pagination>
            </span>
        </el-dialog>

        <!--已推荐列表-->
        <el-dialog title="已推荐" :visible.sync="dialogAlreadRecommend" width="70%" :before-close="hideDialogAlreadRecommend">
            <!--查询条件end --111e-->
            <el-table ref="multipleTable" v-loading="loadings" :data="listss" :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" border>
                <el-table-column label="缩略图" prop="commodityurl" width="80" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.commodityurl" style="width: 50px;height: 50px;" />
                    </template>
                </el-table-column>
                <el-table-column label="产品编码" prop="commoditynum" align="center" />
                <el-table-column label="商品名称" prop="commodityname" :show-overflow-tooltip="true" align="center" />
                <el-table-column label="分类" prop="classifytitle" align="center" />
                <el-table-column label="品牌" prop="brandtitle" align="center" />
                <el-table-column label="价格" align="center" prop="specprice">
                    <template slot-scope="scope">
                        <span v-if="scope.row.specprice">${{scope.row.specprice | price(scope.row.specprice)}}</span>
                        <span v-else>$0</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号" prop="commoditysort" align="center" />
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="removeRecomCommodity(scope.row.recomcommodityid)">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
import {
    getCanRecomCommodity,
    getAlreadyRecomCommodity,
    addRecomCommoditys,
    removeRecomCommoditys,
} from "../../api/product/product";
export default {
    data() {
        return {
            dialogVisble: false, //弹框开关
            loadings: false,
            lists:[],
            listss:[],
            querys: {
                //查询条件
                currentPage: 1,
                pageSize: 6,
                classifyid: "", //分类
                commodityid:"",
                senceId: "", //场景
                commodityname: "", //商品名称
            },
            count: 0, //当前已推荐个数
            totalNumbers:0,
            commodityid:"",
            comClassifys:JSON.parse(sessionStorage.getItem('comClassifys')),
            comSence:JSON.parse(sessionStorage.getItem('comSence')),
            dialogAlreadRecommend:false,
        };
    },

    methods: {
        /*刷新*/
        onRests() {
            //刷新事件需要重置查询条件
            this.querys = {
                currentPage: 1,
                pageSize: 6,
            };
            this.querys.commodityid = this.commodityid;
            this.getCanRecomCommodity();
        },
        /*显示推荐列表弹框*/
        openDialog(commodityid, count) {
            this.dialogVisble = true;
            this.commodityid = commodityid;
            this.querys.commodityid = commodityid;
            this.count = count;
            this.getCanRecomCommodity();
        },
        /*隐藏推荐列表弹框*/
        hideDialogRecommend() {
            this.dialogVisble = false;
        },
        /*获取推荐列表*/
        getCanRecomCommodity() {
            this.loadings = true;
            getCanRecomCommodity(this.querys)
                .then((response) => {
                    this.loadings = false;
                    if (response.code != 0) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.lists = response.data.list || [];
                    this.totalNumbers = response.data.totalNumber || 0;
                })
                .catch(() => {
                    this.loadings = false;
                    this.lists = [];
                });
        },
        /*已推荐弹框*/
        showDialogAlreadRecommend() {
            this.dialogAlreadRecommend = true;
            this.getAddRecomCommodityList();
        },
        hideDialogAlreadRecommend() {
            this.dialogAlreadRecommend = false;
        },

        /*获取已推荐列表*/
        getAddRecomCommodityList() {
            this.loadings = true;
            let data = {
                commodityid: this.commodityid,
            };
            getAlreadyRecomCommodity(data)
                .then((response) => {
                    this.loadings = false;
                    if (response.code != 0) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.listss = response.data || [];
                })
                .catch(() => {
                    this.loadings = false;
                    this.listss = [];
                });
        },
        /*选择每页条数【10,20,30,40,50】*/
        handleSizeChanges(val) {
            this.querys.pageSize = val;
            this.getCanRecomCommodity();
        },
        /*点击页数*/
        handleCurrentChanges(val) {
            this.querys.currentPage = val;
            this.getCanRecomCommodity();
        },
        /*添加推荐商品事件*/
        addRecomCommodity(commodityid) {
            let data = {
                commodityid: this.commodityid,
                recommodityid: commodityid,
            };
            addRecomCommoditys(new URLSearchParams(data))
                .then((response) => {
                    if (response.code != 0) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("添加成功");
                    this.$emit("addcount")//更新列表页推荐数量
                    this.count = this.count + 1;
                    this.getCanRecomCommodity();
                })
                .catch(() => {});
        },
        /*移除推荐商品事件*/
        removeRecomCommodity(commodityid) {
            let data = {
                commodityid: this.commodityid,
                recommodityid: commodityid,
            };
            removeRecomCommoditys(new URLSearchParams(data))
                .then((response) => {
                    if (response.code != 0) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("移除成功");
                    this.$emit("reducecount")//更新列表页推荐数量
                    if(this.count>0){
                        this.count = this.count - 1;
                    }
                    this.getAddRecomCommodityList()
                    this.getCanRecomCommodity();
                })
                .catch(() => {});
        },
        /*列表查询条件事件*/
        onSubmits() {
            this.querys.currentPage = 1;
            this.getCanRecomCommodity();
        },
    },

    filters: {
        price: function (myInput) {
            var val = parseInt(myInput);
            if (typeof val === "number") {
                return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            }
        },
    },
};
</script> 

<style lang="scss" scoped>
.list {
    display: flex;
    flex-wrap: wrap;
    padding-left: 20px;
    .list-item {
        width: 25%;
    }
    .list-item2 {
        width: 20%;
    }
}
.labelClass {
    display: inline-block;
    width: 90px;
    text-align: right;
}
.textBox {
    max-width: 100%;
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    a{
        color: #333;
    }
}
.el-dialog > .el-dialog__footer > .dialog-footer > .pagination-container {
    margin: 10px;
    float: none;
}
.detailbox {
    width: 100%;
    margin-left: 20px;
    display: block;
    img {
        display: block;
        max-width: 100%;
        height: auto !important;
        margin-bottom: 10px;
    }
}
</style>